import { render, staticRenderFns } from "./EmailForm.vue?vue&type=template&id=bd9d315a&"
import script from "./EmailForm.vue?vue&type=script&lang=ts&"
export * from "./EmailForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports